import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconBuilding",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"];
function h(e, t, r, u, _, a) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--building"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Building",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 1.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h1V9a.5.5 0 0 1 .5-.5h3A.5.5 0 0 1 8 9v1.5h1a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H3Zm6 10a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 9 .5H3A1.5 1.5 0 0 0 1.5 2v8A1.5 1.5 0 0 0 3 11.5h6Zm-2-1v-1H5v1h2ZM3.5 3a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, c);
}
const Z = /* @__PURE__ */ s(m, [["render", h]]);
export {
  Z as default
};
//# sourceMappingURL=building.js.map
